import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import App from "./App";
import AuthGate from "./components/AuthGate";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthGate>
    {({ user, signOut }) => <App currentUser={user} onSignOut={signOut} />}
  </AuthGate>
);

// Registers the service worker so the app can be installed (Android/Chrome/
// desktop "Install app" prompt) and the static app shell is cached for
// resilience. API calls to Netlify Functions are NOT cached, so Notion/
// Calendar data always comes fresh over the network.
serviceWorkerRegistration.register();
